/**
 * Keeps browser tabs in sync: signing out in one tab must sign out the others,
 * and signing in elsewhere must not leave this tab on the anonymous view.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@wlb/shared/context/AuthContext';
import { STORAGE_KEYS } from '@wlb/shared/constants';

export function useCrossTabSession(): void {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const onStorage = async (event: StorageEvent) => {
      if (event.key !== STORAGE_KEYS.AUTH_TOKEN) {
        return;
      }
      if (!event.newValue && isAuthenticated) {
        navigate('/', { replace: true });
        await logout();
        return;
      }
      if (event.newValue && !isAuthenticated) {
        window.location.reload();
      }
    };

    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [isAuthenticated, logout, navigate]);
}
